
import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { RefreshCcw } from "lucide-react";
import { GOLD_PURITIES } from "@/lib/constants";
import { GoldPurity } from "@/lib/pricing";

interface GoldFormProps {
  goldPurity: GoldPurity;
  weight: string;
  goldPrice: number;
  onPurityChange: (value: string) => void;
  onWeightChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRefreshPrices: () => void;
  error?: string | null;
}

export function GoldForm({ 
  goldPurity, 
  weight, 
  goldPrice, 
  onPurityChange, 
  onWeightChange,
  onRefreshPrices,
  error
}: GoldFormProps) {
  // Calculate the adjusted price based on selected purity
  const purityMultiplier = GOLD_PURITIES[goldPurity as keyof typeof GOLD_PURITIES]?.multiplier || 1;
  const adjustedPrice = goldPrice * purityMultiplier;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <label htmlFor="gold-purity" className="text-sm font-medium">
            Purezza
          </label>
          <Select value={String(goldPurity)} onValueChange={onPurityChange}>
            <SelectTrigger id="gold-purity">
              <SelectValue placeholder="Seleziona purezza" />
            </SelectTrigger>
            <SelectContent>
              {Object.keys(GOLD_PURITIES).map((purity) => (
                <SelectItem key={purity} value={purity}>
                  {purity}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <label htmlFor="gold-weight" className="text-sm font-medium">
            Peso (g)
          </label>
          <Input
            id="gold-weight"
            type="text"
            inputMode="decimal"
            value={weight}
            onChange={onWeightChange}
            className="text-right"
          />
        </div>
      </div>
      
      <div className="flex justify-between items-center pt-2 border-t">
        <div>
          <div className="text-sm">Prezzo corrente</div>
          <div className="text-lg font-bold">
            {error ? (
              <span className="text-red-500">Non disponibile</span>
            ) : goldPrice > 0 ? (
              `€${adjustedPrice.toFixed(2)}/g`
            ) : (
              <span className="text-muted-foreground">Caricamento...</span>
            )}
          </div>
        </div>
        <Button 
          variant="outline" 
          size="sm" 
          onClick={onRefreshPrices}
          className="h-8"
        >
          <RefreshCcw className="h-4 w-4 mr-1" />
          Aggiorna
        </Button>
      </div>
    </div>
  );
}
